import moment, { Moment } from 'moment-timezone';

export function transformToMoment(value: string): Moment {
    return moment(value, moment.ISO_8601, true);
}
